import { PageHeader } from "../components/helpers";
import { TeamMembers } from "../components/team";

const About = () => {
	return (
		<>
			<PageHeader />

			<div className="content-width headerPadding marginTop-large marginBottom-large">
				<section className="summary plusPattern marginBottom-large text-center">
					<p>
						KPP Architects are an <b>award-winning architectural practice;</b> based in Leeds since 1969, providing full Architectural services in connection with a
						wide range of projects throughout the U.K.
					</p>

					<p>
						Led by the practice's directors, our <b>collaborative approach</b> empowers the collective dialogue that has shaped the practice for over 60 years, a
						dialogue which has <b>the client at its centre</b> and the experience of the KPP team supporting it.
					</p>

					<p>
						The Practice offers a <b>comprehensive range of services</b> including development strategies, master-planning, full architectural service, interior design,
						visuals full architectural service, interior design, visuals and Building Regulations Principal Designer (BRPD). We have experience in multiple building
						sectors to <b>deliver small scale and multi-million pound projects</b> for Industrial, Heritage, Health Care, Retail & Leisure, Workplace, Education and
						Residential projects. We combine our design skill and technical knowledge to deliver high quality projects for our clients, being{" "}
						<b>innovative and progressive</b> in our approach, from concept layout to construction detailing.
					</p>

					<p>
						Our <b>award-winning architecture</b> is supported by a commercial and considered approach to tackling a client's brief, this involves multi-disciplinary,
						<b>collaborative working</b>, within a wider team framework, liaising closely with the client to ensure their <b>aspirations and objectives</b> are being
						delivered.
					</p>
				</section>

				<section>
					<header className="marginBottom-medium">
						<h2>Meet the Team</h2>
					</header>
					<p>
						We believe in positive working relationships with our clients, the wider project team and in-house. This forms the foundation to fully integrated and
						coordinated projects. To this end, all projects are assigned a designated team of experienced personnel, led by a Director, providing consistency for the
						client and wider project team.
					</p>
					<p>
						At the outset of a project we establish the key elements of the client's objectives to deliver an efficient, comprehensive project. We consider factors
						which may affect the deliverability of the scheme, impacting on layout, density, design, viability, sustainability etc. Often this requires
						multi-disciplinary involvement in the early stages of a project, engaging with Statutory Authorities and other professionals in a staged approach, to manage
						the expenditure of up-front costs and to ensure the long-term goals of the project are met effectively and successfully.
					</p>

					<TeamMembers />
				</section>
			</div>
		</>
	);
};

export default About;
